module.exports = __webpack_public_path__ + "img/69.097b9d58.png";